import cn from 'classnames'

import { configuration } from 'mmfintech-checkout-commons'
import { getCurrencyImageUrl } from 'mmfintech-commons'

import { CurrencyIconWrapper } from './CurrencyIcon.styled'

type CurrencyIconProps = {
  currency: string
  size?: string
  circle?: boolean
  className?: string
}

export const CurrencyIcon = ({ currency, size = '3rem', circle = false, className = '' }: CurrencyIconProps) => (
  <CurrencyIconWrapper size={size} className={cn(className, { circle })}>
    <img src={`${configuration.readBackendConfig()}${getCurrencyImageUrl(currency, 'svg')}`} alt='' />
  </CurrencyIconWrapper>
)
